import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import getLenguage from './languaje'

const { tld, resources } = getLenguage();
const savedLanguage = localStorage.getItem('language');
let setTld = 'en';
if (tld === 'esGlobal' || tld === 'enGlobal') {
  setTld = tld === 'esGlobal' ? 'es' : 'en';
} else {
  // En caso de que tld sea 'cl', 'co', 'ec', etc.
  setTld = tld;
}



i18n.use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || setTld,
    fallbackLng: {
      'cl': ['esGlobal'],
      'co': ['esGlobal'],
      'ec': ['esGlobal'],
      'en': ['enGlobal'],
      'es': ['esGlobal']
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
